import { useQuery } from "@tanstack/react-query"
import { API } from "config"

const useConsultant = (id) => useQuery({ queryKey: [`consultant-${id}`], queryFn: async () => {
    if(!id) return {}
    const callback = await API.get(`/consultants/${id}`)
    return callback?.data
}, staleTime: 1000 * 60 * 60 })

export default useConsultant